export const genderKeys = {
  male: "male",
  female: "female",
};

export const extraKeys = {
  withHairLength: "with_hair_length",
  withAge: "with_age",
  skinColor: "skin_color",
  hairColor: "hair_color",
  hairColor2: "hair_color_2",
  hairStyle: "hair_style",
  hairStyle2: "hair_style_2",
  ageGroup: "age_group",
  gender: "gender",
  race: "race",
  seed: "seed",
  isUser: "is_user",
  isNsfw: "is_nsfw",
  isChildRestrict: "is_child_restrict",
  targetSize: "target_size",
  config: "config",
  withRoop: "with_roop",
  refinerConfigId: "refiner_config_id",
  notSafeContentData: "not_safe_content_data",
  promptValuesHash: "prompt_values_hash",
  promptValuesKeys: "prompt_values_keys",
  postEffect: "post_effect",
  handlerResult: "handler_result",
  unsafeContentResult: "unsafe_content_result",
};

export const ageGroups = [
  {
    id: "kid",
    range: [0, 9],
    value: {
      [genderKeys.male]: "small 5 years old child boy",
      [genderKeys.female]: "small 5 years old child girl"
    }
  },
  {
    id: "teenager",
    range: [10, 19],
    value: {
      [genderKeys.male]: "15 years old teenager male",
      [genderKeys.female]: "13 years old teenager female"
    }
  },
  {
    id: "young",
    range: [20, 24],
    value: {
      [genderKeys.male]: "young male",
      [genderKeys.female]: "young female"
    }
  },
  {
    id: "adult",
    range: [25, 49],
    value: {
      [genderKeys.male]: "adult male",
      [genderKeys.female]: "female"
    }
  },
  {
    id: "mature",
    range: [50, 69],
    value: {
      [genderKeys.male]: "40 years old mature male",
      [genderKeys.female]: "40 years old woman"
    }
  },
  {
    id: "old",
    range: [70, 999],
    value: {
      [genderKeys.male]: "old grandfather with old body",
      [genderKeys.female]: "old grandmother with old body"
    }
  },
];

export const hairColorsList2 = {
  [genderKeys.female]: [
    {
      text: "Brunette",
      value: "black",
      oldColor: "black",
      color: "#000",
    },
    {
      text: "Dark brown",
      value: "dark brown",
      oldColor: "brunette",
      color: "#533e3c",
    },
    {
      text: "Medium brown",
      value: "medium brown",
      oldColor: "light_brown",
      color: "#96877d",
    },
    {
      text: "Reddish Brown",
      value: "reddish-brown",
      oldColor: "light_brown",
      color: "#cecece",
    },
    {
      text: "Red",
      value: "red",
      oldColor: "red",
      color: "#d66506",
    },
    {
      text: "Dark blonde",
      value: "dark blonde",
      oldColor: "blonde",
      color: "#cecece",
    },
    {
      text: "Blonde",
      value: "blonde",
      oldColor: "blonde",
      color: "#fcf4cb",
    },
    {
      text: "Platinum blonde",
      value: "platinum blonde",
      oldColor: "gray",
      color: "#cecece",
    },
  ],
  [genderKeys.male]: [
    {
      text: "Brunette",
      value: "black",
      oldColor: "black",
      color: "#000",
    },
    {
      text: "Dark brown",
      value: "dark brown",
      oldColor: "brunette",
      color: "#533e3c",
    },
    {
      text: "Medium brown",
      value: "medium brown",
      oldColor: "light_brown",
      color: "#96877d",
    },
    {
      text: "Ginger",
      value: "ginger",
      oldColor: "light_brown",
      color: "#cecece",
    },
    {
      text: "Dark blonde",
      value: "dark blonde",
      oldColor: "blonde",
      color: "#cecece",
    },
    {
      text: "Blonde",
      value: "blonde",
      oldColor: "blonde",
      color: "#fcf4cb",
    },
    {
      text: "Platinum blonde",
      value: "white",
      oldColor: "gray",
      color: "#cecece",
    },
  ],
};

export const hairStylesList2 = {
  [genderKeys.female]: [
    {
      groups: ["bob"],
      value: "afro hair",
    },
    {
      groups: ["bob"],
      value: "curly bob hair with trendy bangs",
    },
    {
      groups: ["bob"],
      value: "layered bob hair",
    },
    {
      groups: ["bob"],
      value: "layered bob hair with trendy bangs",
    },
    {
      groups: ["bob"],
      value: "straight bob hair",
    },
    {
      groups: ["bob"],
      value: "straight bob hair with trendy bangs",
    },
    {
      groups: ["bob"],
      value: "wavy bob hair",
    },
    {
      groups: ["bob"],
      value: "wavy bob hair with trendy bangs",
    },
    {
      groups: ["bob"],
      value: "pixie-cut hair",
    },
    {
      groups: ["normal"],
      value: "hair with ponytail",
    },
    {
      groups: ["normal"],
      value: "shoulder-length curly hair",
    },
    {
      groups: ["normal"],
      value: "shoulder-length curly hair with trendy bangs",
    },
    {
      groups: ["normal"],
      value: "shoulder-length layered hair",
    },
    {
      groups: ["normal"],
      value: "shoulder-length layered hair with trendy bangs",
    },
    {
      groups: ["normal"],
      value: "shoulder-length straight hair",
    },
    {
      groups: ["normal"],
      value: "shoulder-length straight hair with trendy bangs",
    },
    {
      groups: ["normal"],
      value: "shoulder-length wavy hair",
    },
    {
      groups: ["normal"],
      value: "shoulder-length wavy hair with trendy bangs",
    },
    {
      groups: ["long"],
      value: "long curly hair",
    },
    {
      groups: ["long"],
      value: "long curly hair with trendy bangs",
    },
    {
      groups: ["long"],
      value: "long layered hair",
    },
    {
      groups: ["long"],
      value: "long layered hair with trendy bangs",
    },
    {
      groups: ["long"],
      value: "long straight hair",
    },
    {
      groups: ["long"],
      value: "long straight hair with trendy bangs",
    },
    {
      groups: ["long"],
      value: "long wavy hair",
    },
    {
      groups: ["long"],
      value: "long wavy hair with trendy bangs",
    },
    {
      groups: ["other"],
      value: "hair with braids",
    },
    {
      groups: ["other"],
      value: "hair with bun",
    },
    {
      groups: ["other"],
      value: "hair with dreadlocks",
    },
    {
      groups: ["other"],
      value: "wearing hijab",
    },
    {
      groups: ["other"],
      value: "mohawk hair",
    },
    {
      groups: ["bob"],
      value: "curly bob hair",
    },
  ],
  [genderKeys.male]: [
    {
      groups: ["other"],
      value: "with bald head"
    },
    {
      groups: ["other"],
      value: "wearing baseball cap"
    },
    {
      groups: ["other"],
      value: "wearing beanie"
    },
    {
      groups: ["other"],
      value: "wearing bucket hat"
    },
    {
      groups: ["other"],
      value: "wearing hood"
    },
    {
      groups: ["other"],
      value: "wearing sun hat"
    },
    {
      groups: ["buzz-cut"],
      value: "buzz cut with receding hairline"
    },
    {
      groups: ["buzz-cut"],
      value: "buzz cut"
    },
    {
      groups: ["crew"],
      value: "caesar cut"
    },
    {
      groups: ["crew"],
      value: "crew cut"
    },
    {
      groups: ["crew"],
      value: "slicked back hair"
    },
    {
      groups: ["crew"],
      value: "taper cut"
    },
    {
      groups: ["crew"],
      value: "undercut"
    },
    {
      groups: ["crew"],
      value: "wavy caesar cut"
    },
    {
      groups: ["crew"],
      value: "short hair with bangs"
    },
    {
      groups: ["normal"],
      value: "medium length curly hair"
    },
    {
      groups: ["normal"],
      value: "medium-length tousled hair"
    },
    {
      groups: ["normal"],
      value: "fauxhawk"
    },
    {
      groups: ["long"],
      value: "long chest-length dreadlocks"
    },
    {
      groups: ["long"],
      value: "long curly hair"
    },
    {
      groups: ["long"],
      value: "long wavy hair"
    },
  ],
};

export function normalizeGender(gender) {
  gender = (gender || "").toLowerCase();

  if (["male", "man", "boy"].includes(gender)) {
    return "male";
  } else {
    return "female";
  }
}

export function normalizeRace(value) {
  const constantRaceList = ["caucasian", "african american", "asian", "indian", "middle eastern", "hispanic"];

  if (!constantRaceList.includes(value)) {
    if (value === "black") return "african american";
    if (value === "arabic") return "middle eastern";

    return "caucasian";
  }

  return value;
}

export function normalizeSkinColor(color) {
  color = (color || "").toLowerCase();

  if (["white", "black", "brown"].includes(color)) {
    return color;
  } else {
    return "white";
  }
}

export function normalizeAgeGroup(value) {
  const intValue = parseInt(value);
  const group = ageGroups.find((group) => {
    return intValue >= group.range[0] && intValue <= group.range[1];
  });

  if (group) {
    return group.id;
  }

  const strValue = ("" + value).toLowerCase();
  if (strValue === "old") {
    return "old";
  } else if (strValue === "middle aged") {
    return "adult";
  }

  return strValue;
}

export function normalizeHairColor(sourceColor) {
  sourceColor = (sourceColor || "").toLowerCase();
  sourceColor = sourceColor.split(" and ")[0];
  sourceColor = sourceColor === "yellow" ? "blonde" : sourceColor;
  sourceColor = sourceColor === "white" ? "gray" : sourceColor;
  sourceColor = sourceColor === "brown" ? "brunette" : sourceColor;

  return sourceColor;
}

export function convertNewHairStyleToOld(gender, value) {
  const {groups} = hairStylesList2[gender].find((h) => h.value === value);

  if (groups && groups.first() === "other") {
    return gender === "female" ? "pixie-cut" : "bald";
  }

  return groups.first();
}

export function convertNewHairColorToOld(gender, newHairColor) {
  return hairColorsList2[gender]?.find((i) => i.value === newHairColor)?.oldValue;
}

export function normalizeHairStyle2(string) {
  return string.replace(/[()]/g, "");
}
